'use client'

import isClient from '@/utils/browser/isClient'
import useMediaQuery from '@/utils/browser/getDeviceScreen'

import { Autoplay, Pagination } from 'swiper/modules'

import { CASES } from './constants'

const useCases = () => {
  const isMobile = useMediaQuery('mobile')
  const isDesktop = useMediaQuery('desktop')

  const itens = Object.values(CASES)

  const settings = {
    slidesPerView: isClient() && !isMobile ? (isDesktop ? 4.5 : 2.7) : 1.2,
    spaceBetween: 24,
    centeredSlides: true,
    autoplay: {
      delay: 1000,
      disableOnInteraction: false
    },
    speed: 2000,
    loop: true,
    pagination: {
      clickable: true
    },
    modules: [Pagination, Autoplay]
  }

  return {
    itens,
    settings
  }
}

export default useCases
